import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './profileAreaShimmerComponent.css';

const ProfileAreaShimmerComponent = () => {
  return (
    <div className="et-v2-profile-area-shimmer-container">
      <div className="et-v2-pas-profile-media-tabs-wrap">
        <div className="et-v2-pas-profile-media-tab">
          <ShimmerComponent />
        </div>
        <div className="et-v2-pas-profile-media-tab">
          <ShimmerComponent />
        </div>
      </div>
      <div className="et-v2-pas-title-content-wrap">
        {Array.from({length: 3}).map((val, idx) => (
          <div key={idx}>
            <div className="et-v2-pas-profile-media-tab">
              <ShimmerComponent />
            </div>
            <div className="et-v2-pas-content">
              <ShimmerComponent />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileAreaShimmerComponent;
